<template>
  <v-container fluid class="exchange-settings-page pa-2 my-3 sm:pa-4 sm:my-6">
    <header class="mb-5 flex items-center gap-3">
      <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-50 text-emerald-800">
        <v-icon size="22">mdi-chart-line-variant</v-icon>
      </span>
      <div>
        <h1 class="text-xl font-bold text-slate-900">تنظیمات صرافی</h1>
        <p class="mt-1 text-sm text-slate-500">کارمزد معاملات و پارامترهای مارکت‌میکر</p>
      </div>
    </header>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card class="exchange-settings-card mb-4">
        <v-card-title class="exchange-settings-title">
          <v-icon color="primary" size="21">mdi-cash-multiple</v-icon>
          کارمزد معاملات
        </v-card-title>
        <v-card-text>
          <v-row class="pa-2 sm:pa-4">
            <!-- کارمزدهای ریالی -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeBuyRiali" label="درصد کارمزد خرید ریالی (%)" type="number"
                step="0.01" prefix="%" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeSellRiali" label="درصد کارمزد فروش ریالی (%)" type="number"
                step="0.01" prefix="%" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeFixedRiali" label="کارمزد ثابت ریالی (تومان)" type="number"
                suffix="تومان" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeCapRiali" label="سقف کارمزد ریالی (تومان)" type="number"
                suffix="تومان" hint="0 = بدون محدودیت" persistent-hint :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <!-- کارمزدهای تتری -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeBuyUsdt" label="درصد کارمزد خرید تتری (%)" type="number" step="0.01"
                prefix="%" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeSellUsdt" label="درصد کارمزد فروش تتری (%)" type="number"
                step="0.01" prefix="%" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeFixedUsdt" label="کارمزد ثابت تتری (USDT)" type="number" step="0.01"
                suffix="USDT" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="form.tradingFeeCapUsdt" label="سقف کارمزد تتری (USDT)" type="number" step="0.01"
                suffix="USDT" hint="0 = بدون محدودیت" persistent-hint :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- تنظیمات مارکت میکر -->
      <v-card class="exchange-settings-card">
        <v-card-title class="exchange-settings-title">
          <v-icon color="primary" size="21">mdi-chart-bell-curve-cumulative</v-icon>
          تنظیمات مارکت میکر
        </v-card-title>
        <v-card-text>
          <v-row class="pa-2 sm:pa-4">
            <v-col cols="12" sm="6">
              <v-text-field v-model="form.marketMakerSpread" label="اسپرد مارکت میکر" type="number" step="0.001"
                prefix="≈" suffix="%" hint="مثال: 0.005 = 0.5%" persistent-hint :rules="[rules.positive]" outlined
                dense />
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field v-model="form.marketMakerMinSpreadToman" label="حداقل اسپرد (تومان)" type="number"
                suffix="تومان" :rules="[rules.positiveOrZero]" outlined dense />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- دکمه‌های عملیات -->
      <v-row class="mt-4">
        <v-col class="flex flex-wrap gap-2">
          <v-btn color="primary" rounded="lg" prepend-icon="mdi-content-save-outline" @click="submit" :disabled="!valid">
            ذخیره تغییرات
          </v-btn>
          <v-btn variant="outlined" rounded="lg" prepend-icon="mdi-restore" @click="reset">
            بازنشانی
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import store from '@/store';

export default {
  name: 'TradingFeeForm',
  data() {
    return {
      valid: true,
      form: {
        tradingFeeBuyRiali: 0,
        tradingFeeSellRiali: 0,
        tradingFeeBuyUsdt: 0,
        tradingFeeSellUsdt: 0,
        tradingFeeFixedRiali: 0,
        tradingFeeFixedUsdt: 0,
        tradingFeeCapRiali: 0,
        tradingFeeCapUsdt: 0,
        marketMakerSpread: 0,
        marketMakerMinSpreadToman: 0,
      },
      rules: {
        positive: (v) => v > 0 || 'مقدار باید مثبت باشد',
        positiveOrZero: (v) => v >= 0 || 'مقدار نمی‌تواند منفی باشد',
      },
    };
  },

  computed: {
    getExchangeSetting() {
      return store.getters["panel/getExchangeSetting"];
    }
  },

  methods: {
    toNumbers(obj) {
      const result = {};
      for (const key in obj) {
        // `v-model` on <v-text-field type="number"> gives a string
        // Empty string → keep as 0 (or you can set null)
        const val = obj[key];
        result[key] = val === '' ? 0 : Number(val); // or parseFloat(val)
      }
      return result;
    },

    submit() {
      if (this.$refs.form.validate()) {
        const payload = this.toNumbers(this.form);
        store.dispatch("panel/editExchangeSettingRequest", { settingId: this.getExchangeSetting.id, setting: payload })
        // this.$emit('submit', payload);
      }
    },
    reset() {
      this.$refs.form.reset();
      this.form = {
        tradingFeeBuyRiali: this.getExchangeSetting.tradingFeeBuyRiali,
        tradingFeeSellRiali: this.getExchangeSetting.tradingFeeSellRiali,
        tradingFeeBuyUsdt: this.getExchangeSetting.tradingFeeBuyUsdt,
        tradingFeeSellUsdt: this.getExchangeSetting.tradingFeeSellUsdt,
        tradingFeeFixedRiali: this.getExchangeSetting.tradingFeeFixedRiali,
        tradingFeeFixedUsdt: this.getExchangeSetting.tradingFeeFixedUsdt,
        tradingFeeCapRiali: this.getExchangeSetting.tradingFeeCapRiali,
        tradingFeeCapUsdt: this.getExchangeSetting.tradingFeeCapUsdt,
        marketMakerSpread: this.getExchangeSetting.marketMakerSpread,
        marketMakerMinSpreadToman: this.getExchangeSetting.marketMakerMinSpreadToman,
      };
    },
  },

  mounted() {
    store.dispatch("panel/getExchangeSettingRequest").then(() => {
      this.reset();
    });
  }
};
</script>

<style scoped>
.exchange-settings-page {
  max-width: 1200px;
  margin-inline: auto;
}

.exchange-settings-card {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, .04);
}

.exchange-settings-title {
  display: flex;
  align-items: center;
  gap: .75rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  font-weight: 700;
}

.exchange-settings-card :deep(.v-input) {
  min-width: 0;
}
</style>